import { LoanPhaseDto } from "src/types/api";

export const sortPhasesByDisplayOrder = (phases: LoanPhaseDto[]): LoanPhaseDto[] => {
    return phases.sort((a, b) => a.displayOrder - b.displayOrder);
};